(function ($) {
    
    function arrowClicks(){
        $('.nav-menu a').on('click',function(e) {
            
            var href = $(this).attr('href');
            
            if (href === '#' && $(this).parent().hasClass('menu-item-has-children')){
                e.preventDefault();
                $( this ).siblings('.sub-menu').addClass('active');
                $( this ).closest('.menu-item').addClass('open');
                $( this ).parent().siblings('.menu-item').addClass('hidden');
            }
        });
        $('.nav-menu li .arrow').on('click',function(e) {
            e.preventDefault();
            $( this ).next().addClass('active');
            $( this ).closest('.menu-item').addClass('open');
            $( this ).parent().siblings('.menu-item').addClass('hidden');
            $( this ).closest('.sub-menu').addClass('parent');
        });
        $('.sidr__menu-back').on('click',function(){
            var menuCloseId = $( this ).data('sidr-menu');
            $( '#' + menuCloseId ).removeClass('active');
            $( '#' + menuCloseId ).parents('.sub-menu').removeClass('parent');
            $( this ).closest('.menu-item').removeClass('open');
            
            $( this ).parent().closest('.menu-item').siblings('.menu-item').removeClass('hidden');
        });
    }
    
    function stickyNav(){
        var $scrollTop = $(window).scrollTop();
        
		if ($scrollTop > 74) { //80 + 57
			$('#masthead').addClass('sticky');
		} else {
			$('#masthead').removeClass('sticky');
		}
	};
    
    function hasClass(element, className) {
        if (element.classList.contains(className)) {
            console.log(`Element has the "${className}" class.`);
            return true;
        } else {
            console.log(`Element does NOT have the "${className}" class.`);
            return false;
        }
    }

	/* Document Ready */
	$(document).ready(function() {
        
        AOS.init({
            duration: 400,
            once: false,
            anchorPlacement: 'top-bottom'
        });
        
        /* Jarallax requirements */
        // object-fit polyfill run
        objectFitImages();

        // init Jarallax
        jarallax(document.querySelectorAll('.jarallax'), {
            disableParallax: /iPhone|iPod|Android/,
        });

        jarallax(document.querySelectorAll('.jarallax-keep-img'), {
            keepImg: true,
        });
        
        const myDiv = document.querySelector('.site-header');
        var $sidr_class;
        if (hasClass(myDiv, 'site-header-light')) {
            $sidr_class = 'light';
        }else{
            $sidr_class = 'dark';
        }
        
        $('#mobile-trigger').sidr({
            side: 'left',
            name: 'sidr',
            displace: false,
            source : function() {
                var sidrHtml;
                
                sidrHtml = '<section id="mobile-menu" class="' + $sidr_class + '">';
                
                sidrHtml += '<section class="sidr__header">';
                if($('.site-logo').length){
                    sidrHtml += '<div class="sidr__logo">';
                    sidrHtml += '<a href="/">' + $('.site-logo .logo-img').html() + '</a>';
                    sidrHtml += '</div>';
                    
                }
                sidrHtml += '<button class="sidr__close" aria-label="Close"><span class="screen-reader-text">Close</span></button>';
                sidrHtml += '</section>';
                
                sidrHtml += '<div class="sidr__inner">';
                sidrHtml += '<nav class="sidr__mainnav" aria-label="Mobile">';
                sidrHtml += '<ul class="nav-menu">';
                    
                if($('.main-navigation').length){
                    sidrHtml += $('.main-navigation .nav-menu').html();
                }
                
                sidrHtml += '</ul>';
                sidrHtml += '</nav>';
                
                if($('#site-header-contact').length){
                    sidrHtml += '<div class="sidr__subnav">';

                    var contactUrl = $('#site-header-contact').attr('href');
                    sidrHtml += '<a href="' + contactUrl + '" class="button button-primary-default" id="sidr__contact">' +  $('#site-header-contact').html() + '</a>';
                    
                    sidrHtml += '</div>';
                }
                
                sidrHtml += '</div>';
                sidrHtml += '</section>';
                    
                return sidrHtml;
            },
            onOpen: function() {
                var headerHeight = $("#masthead").height(),
                    windowHeight = $(window).height();
                
                $('#mobile-trigger').addClass('active');
                $('#masthead').addClass('mobile');
                
                $( '.site-content' ).prepend( '<div class="sidr-overlay"></div>' );
                
                $('.sidr__inner').find('.sub-menu').each(function() {
                    var menuId = $(this).parents('.menu-item').attr('id'),
                        parentLink = $(this).prevAll('a').attr('href'),
                        parentText = $(this).prevAll('a').html();
                    
                    $(this).attr('id','sidr-' + menuId).prepend('<li class="sidr__menu-back" data-sidr-menu="sidr-' + menuId + '">' + parentText + '</li>');
                });
            },
            onOpenEnd: function(){
                arrowClicks();
            },
            onClose: function(){
                $('#mobile-trigger').removeClass('active');
                $( '.sidr-overlay' ).remove();
                $('#masthead').removeClass('mobile');
            },
            onCloseEnd: function(){
                $('.sidr__inner').find('.sub-menu').each(function() {
                    $(this).find('.sidr__menu-back').remove();
                });
            }
        });
        
        $('.sidr__close').click(function() {
            $.sidr('close','sidr');
            $('.nav-menu li .arrow').unbind();
            $('sidr__menu-back').unbind();
            stickyNav();
        });
        
        stickyNav();

	});
    
    //on resize
    let samt = 0;
    window.addEventListener('scroll', function() {
        samt <= 10 ? samt++ : AOS.refresh();
        samt <= 10 ? samt++ : stickyNav();
    });

    
})(jQuery);